import { render, staticRenderFns } from "./commission-deductions-loader.vue?vue&type=template&id=8066b8aa"
import script from "./commission-deductions-loader.vue?vue&type=script&lang=ts"
export * from "./commission-deductions-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports